<template>
    <div class="mod d-none">
        <div class="mod-overlay"></div>
        <div class="modal-body">
            <spinner :data="spinnerData"></spinner>
            <div class="modal-header">
                <button type="button" @click="skip" class="btn btn-secondary">Skip</button>
                <h5 class="modal-title" @click="maximize" id="exampleModalLongTitle">Edit Image</h5>
                <button type="button" @click="crop" class="btn btn-success">Apply</button>
            </div>
            <div class="content-area">
                <div :style="{backgroundImage: 'url(' + imgSrc + ')'}" class="cropper-background"></div>
                <section class="cropper-area">
                    <cropper
                            classname="cropper"
                            ref="cropper"
                            :src="imgSrc"
                            :stencilComponent="$options.components.CircleStencil"
                            :stencil-props="{
                                previewClassname: 'preview',
                                // minAspectRatio: 8/8,
                                // maxAspectRatio: 10/8,
                                handlers: {
                                    eastNorth: true,
                                    north: true,
                                    westNorth: true,
                                    west: true,
                                    westSouth: true,
                                    south: true,
                                    eastSouth: true,
                                    east: true,
                                },
                            }"
                    ></cropper>

                </section>
                <section class="preview-area d-none">

                </section>
            </div>
            <div class="modal-footer">
                <div class="actions">
                    <button type="button" @click="center" class="btn btn-outline-primary">Center</button>
                </div>
                <button type="button" @click="cancel" class="btn btn-secondary">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { Cropper, CircleStencil  } from 'vue-advanced-cropper'
    export default {
        name: "EditPictureModal",
        data() {
            return {
                imgSrc: '/image/PREMIERLEAGUE-BRANDING-WALLPAPERWHEATPASTE.jpg',
                cropImg: '',
                data: null,
                spinnerData: {},
            };
        },
        components: {
            Cropper,
            CircleStencil,
        },
        watch: {
            imgData(val) {
                this.imgSrc = val
                // console.log('image data',val)
                $('.mod').removeClass('d-none')
            },
        },
        props: ['imgData','from'],
        mounted() {
            // $('#editPictureModal').modal('show')
            // $('.mod').removeClass('d-none')
        },
        methods: {
            showLoading(options = {}) {
                let loader = this.spinnerData = {
                    spinner: 'Jumper',
                    isLoading: options.show !== undefined ? options.show : true ,
                    color: '#00bfff',
                    size: '60px',
                    options: 'center absolute',
                };
                return loader;
            },
            // skip the image to upload like that
            skip() {
                this.crop(true)
            },
            // cancel uploading and croping
            cancel() {
                $('.mod').addClass('d-none')
                this.imgSrc = '';
            },
            // used just for debuging to show the cordinates of the edited image
            change({coordinates, canvas}) {
                console.log(coordinates, canvas)
            },
            // we convert our cropped image to blob for upload
            b64toBlob(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },
            // used to crop the image
            crop(isSkip = false) {
                const {coordinates, canvas} = this.$refs.cropper.getResult()
                this.coordinates = coordinates
                // You able to do different manipulations at a canvas
                // but there we just get a cropped image
                let ImageURL = '';
                if (isSkip) {
                    ImageURL = this.imgSrc
                }else {
                    ImageURL = canvas.toDataURL();
                }
                // Split the base64 string in data and contentType
                var block = ImageURL.split(";");
                // Get the content type of the image
                var contentType = block[0].split(":")[1];// In this case "image/gif"
                // get the real base64 content of the file
                var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

                // Convert it to a blob to upload
                var blob = this.b64toBlob(realData, contentType);
                //after convertions we check where the image is coming from and send the data as an event to the requesting component
                // for processing
                if(this.$props.from === 'profile') {
                    const data = {
                        blob: blob,
                        imageUri: ImageURL,
                    }
                    window.eventBus.$emit('updateProfile', data)
                }
            },
            // we use this to restrict the image picxel during editing
            pixelsRestriction({minWidth, minHeight, maxWidth, maxHeight, imageWidth, imageHeight}) {
                return {
                    minWidth: minWidth,
                    minHeight: minHeight,
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                }
            },
            // we resize the image during resizing
            resize(width, height, left, top) {
                this.$refs.cropper.setCoordinates({
                    width: width,
                    height: height,
                    left: left,
                    top: top,
                })
            },
            // we center the image during resizing
            center() {
                this.$refs.cropper.setCoordinates((coordinates, imageSize) => ({
                    left: imageSize.width/2 - coordinates.width/2,
                    top: imageSize.height/2 - coordinates.height/2,
                }))
            },
            // we maximize the image during resizing
            maximize() {
                this.$refs.cropper.setCoordinates((coordinates, imageSize) => ({
                    width: imageSize.width,
                    height: imageSize.height,
                }))
            },
        },
    }
</script>

<style scoped>
    .preview {
        border: dashed 1px rgba(255,255,255, 0.25);
    }
.content-area {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
    max-height: 400px;
    overflow: auto;
    float: left;
    position: relative;
}
.cropper-area {
    border:solid 4px #2b7415;
    width: 100%;
    height: 100%;
}
.cropper-background {
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: 50%;
    filter: blur(5px);
    opacity: 0.25;
}

section {
    padding: 0 !important;
}
.actions button {
    color: #000000;
}
.actions button:hover {
    color: #ffffff;
}
.mod {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10000;
}
.mod .mod-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0,0,0,.8);
}
.mod .modal-body {
    position: relative;
    z-index: 1;
    width: 650px;
    min-height: 600px;
    background-color: #fff;
    border-radius: 6px;
    margin: 30px auto;
    padding: 10px;
}
.mod .modal-header {
    width: 100%;
    float: left;
    padding: 10px;
}
.mod .modal-footer {
    width: 100%;
    float: left;
    padding: 10px;
}
@media (max-width: 768px) {
    .mod .modal-body {
        width: 80%;
    }
}
</style>